<ng-container *ngTemplateOutlet="isNarrative ? narrativeTemplate : groupTemplate" />
<ng-template #groupTemplate>
  <div class="td-wb-input-group-field--flex">
    <div class="td-wb-input-group-field__infix">
      <ng-content />
    </div>
    @if (!isNarrative) {
      <div class="td-wb-input-group-field__suffix">
        <ng-container *ngTemplateOutlet="suffixTemplate" />
      </div>
    }
  </div>
  <div>
    <ng-content select="td-wb-input-errors" />
    <ng-content select="td-wb-input-group-note" />
  </div>
</ng-template>

<ng-template #narrativeTemplate>
  <div class="td-wb-input-group-field">
    <div class="td-wb-input-group-field__content">
      <ng-container *ngTemplateOutlet="groupTemplate" />
    </div>
    <div class="td-wb-input-group-field__suffix">
      <ng-container *ngTemplateOutlet="suffixTemplate" />
    </div>
  </div>
</ng-template>

<ng-template #suffixTemplate>
  <ng-content select="td-wb-input-group-suffix" />
</ng-template>
